import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import Cookies from 'js-cookie';
import { loginWithToken } from '../../../store/auth/authSlice';
import { RegisterPage, GameBg, PageBody, CentreCol, RegisterCard } from './RegisterStyle';

const GoogleCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const token = searchParams.get('token');
    if (!token) {
      navigate('/login?error=google_failed');
      return;
    }

    Cookies.set('token', token, { expires: 1 });

    axios.post('/api/check_auth', {}, {
      headers: { Authorization: token }
    })
      .then(({ data }) => {
        dispatch(loginWithToken({ token: data.token, user: data.user }));
        navigate('/profile');
      })
      .catch(() => {
        navigate('/login?error=google_failed');
      });
  }, []);

  return (
    <RegisterPage>
      <GameBg>
        <PageBody>
          <CentreCol>
            <RegisterCard>
              <div className="card-top-icon" style={{ fontSize: 22 }}>⏳</div>
              <h2 className="card-title">جارٍ تسجيل الدخول…</h2>
              <p className="card-subtitle">يرجى الانتظار بينما نقوم بتسجيل دخولك عبر Google.</p>
            </RegisterCard>
          </CentreCol>
        </PageBody>
      </GameBg>
    </RegisterPage>
  );
};

export default GoogleCallback;
